import { CompanyMoneyFormatWithSymbol } from '@libs/money/money.interfaces';

export function formatWithLocale(
    amount: number,
    fullLocale: string,
    moneyFormat: CompanyMoneyFormatWithSymbol
): string {
    const { currency, numberOfDecimals } = moneyFormat;

    if (currency === undefined) {
        return `${amount}`;
    }

    return getNumberFormatter(amount, currency, fullLocale, numberOfDecimals);
}

export function formatWithCurrency(
    amount: number,
    currency: string,
    fullLocale: string,
    moneyFormat: CompanyMoneyFormatWithSymbol
): string {
    const currentCurrency =
        currency !== undefined && currency !== '' ? currency : moneyFormat.currency;
    return getCurrencyFormatter(
        amount,
        currentCurrency,
        fullLocale,
        moneyFormat.numberOfDecimals
    );
}

function getCurrencyFormatter(
    amount: number,
    currencyCode: string,
    fullLocale: string,
    numberOfDecimals: number
): string {
    if (amount % 1 === 0) {
        return new Intl.NumberFormat(fullLocale, {
            style: 'currency',
            currency: currencyCode,
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
        }).format(amount);
    }

    return new Intl.NumberFormat(fullLocale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: numberOfDecimals,
    }).format(amount);
}

function getNumberFormatter(
    amount: number,
    currencyCode: string,
    fullLocale: string,
    numberOfDecimals: number
): string {
    if (amount % 1 == 0) {
        return new Intl.NumberFormat(fullLocale, {
            style: 'currency',
            currency: currencyCode,
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
        }).format(amount);
    }

    return new Intl.NumberFormat(fullLocale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: numberOfDecimals,
    }).format(amount);
}
